import React from 'react'

interface ActivityItem {
  id: string
  icon: 'upload' | 'download' | 'edit' | 'delete'
  title: string
  date: string
}

const activities: ActivityItem[] = [
  {
    id: '1',
    icon: 'upload',
    title: 'Uploaded 25 Files',
    date: 'Jun 25, 2025'
  }
]

const ActivityIcon: React.FC<{ type: ActivityItem['icon'] }> = ({ type }) => {
  const iconStyle = { color: '#6366F1', width: '20px', height: '20px' }

  switch (type) {
    case 'upload':
      return (
        <svg style={iconStyle} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12'
          />
        </svg>
      )
    case 'download':
      return (
        <svg style={iconStyle} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4'
          />
        </svg>
      )
    case 'edit':
      return (
        <svg style={iconStyle} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z'
          />
        </svg>
      )
    case 'delete':
      return (
        <svg style={iconStyle} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'
          />
        </svg>
      )
    default:
      return null
  }
}

const RecentActivity: React.FC = () => {
  return (
    <div className='card shadow-sm border-0 rounded-4 mt-4'>
      <div className='card-body p-4'>
        {/* Header */}
        <div className='d-flex justify-content-between align-items-center mb-3'>
          <h5 className='card-title mb-0 fw-semibold'>Recent Activity</h5>
          <button className='btn btn-link text-secondary p-0'>
            <svg width='20' height='20' fill='currentColor' viewBox='0 0 20 20'>
              <circle cx='10' cy='4' r='1.5' />
              <circle cx='10' cy='10' r='1.5' />
              <circle cx='10' cy='16' r='1.5' />
            </svg>
          </button>
        </div>

        {/* Activity List */}
        <div className='d-flex flex-column gap-3'>
          {activities.map((activity) => (
            <div key={activity.id} className='d-flex align-items-start gap-3'>
              <div
                className='rounded-3 d-flex align-items-center justify-content-center flex-shrink-0'
                style={{
                  width: '40px',
                  height: '40px',
                  backgroundColor: 'rgba(99, 102, 241, 0.1)'
                }}
              >
                <ActivityIcon type={activity.icon} />
              </div>
              <div className='d-flex flex-column'>
                <span className='small fw-medium text-dark'>{activity.title}</span>
                <span className='text-muted' style={{ fontSize: '12px' }}>
                  {activity.date}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RecentActivity
